import { module } from 'angular';

import {
  AgentBookingChatIadvizeInprocess,
  default as agentBookingChatIadvizeInprocess,
} from './inprocess/agent-booking-chat-iadvize-inprocess.component.ajs';

export default module('contact.agent.contact-view.chat-iadvize.state', []).component(
  agentBookingChatIadvizeInprocess,
  new AgentBookingChatIadvizeInprocess()
).name;
